import { render, staticRenderFns } from "./FooterTemplatePage.vue?vue&type=template&id=076fbd56&"
import script from "./FooterTemplatePage.vue?vue&type=script&lang=js&"
export * from "./FooterTemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports